import React from "react";
import LanguagePicker from "../components/LanguagePicker";
import {ArrowLeftRegular} from "@fluentui/react-icons";
import {Button, Text, tokens} from "@fluentui/react-components";
import {useRouter} from "../Router";
import {useTranslation} from "react-i18next";
import Page from "../components/Page";
import {Language, switchLanguage} from "../../i18n";
import {getSsoToken, isDev} from "../../util";
import CopyButton from "../components/CopyButton";

export default function SettingsPage() {
  const {i18n} = useTranslation();
  const {t} = useTranslation();
  const {setPage} = useRouter();

  return (
    <Page>
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        paddingBottom: tokens.spacingVerticalS
      }}>
        <Text size={400} weight="semibold" style={{flex: 1}}>
          {t("translation:settings.title")}
        </Text>
        <Button
          appearance="subtle"
          size="small"
          icon={<ArrowLeftRegular/>}
          onClick={() => setPage({kind: 'list'})}
        >
          {t("translation:general.back")}
        </Button>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM
      }}>
        <LanguagePicker
          label={t("translation:settings.language")}
          value={i18n.language as Language}
          onChange={value => switchLanguage(value)}
        />

        {isDev && (
          <Button
            appearance="secondary"
            onClick={async () => {
              const token = await getSsoToken();
              console.log(token);
            }}
          >
            Log SSO token
          </Button>
        )}

        <CopyButton/>
      </div>
    </Page>
  );
}